import AuthContext from "../Components/AuthProvider";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useContext, useRef } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import ipaddress from "../Components/IpAddress";
import ReactLoading from 'react-loading';
import {
    Card,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Table,
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faFileExcel, faSearch } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { toast } from "react-toastify";
import "../Components/Style.css";
import InviceService from "../services/InviceService";



export default function Scan_Parcels() {
    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // Adjust the opacity and color as needed
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999, // Ensure the overlay is above other elements
        },
    };
    const navigate = useNavigate();
    const {
        userId,
        branchId,
        companyid
    } = useContext(AuthContext);
    const { isAuthenticated } = useContext(AuthContext);
    useEffect(() => {
        if (!isAuthenticated) {
            navigate(
                "/login?message=You need to be authenticated to access this page."
            );
        }
    }, [isAuthenticated, navigate]);


    const [exportincount, setExportinCount] = useState(0);
    const [importincount, setImportincount] = useState(0);

    const [exportoutcount, setExportoutCount] = useState(0);
    const [importoutcount, setImportoutcount] = useState(0);
    const [subexportoutcount, setSubexportoutCount] = useState(0);
    const [subimportoutcount, setSubimportoutcount] = useState(0);
    const [SEEPZInData, setSEEPZInData] = useState([]);
    const [SEEPZOutData, setSEEPZOutData] = useState([]);


    useEffect(() => {
        getSEEPZInData();
        getSEEPZOutData();
    }, []);


    // console.log('SEEPZInData : \n', SEEPZInData, '\nSEEPZOutData : \n', SEEPZOutData);


    const getSEEPZInData = async () => {
        const List = await getData('seepz', ['Import-in', 'Export-in']);
        setSEEPZInData(List);
        const exportInCount = List.filter(item => item.typeOfTransaction === 'Export-in').length;
        setExportinCount(exportInCount);
        const importInCount = List.filter(item => item.typeOfTransaction === 'Import-in').length;
        setImportincount(importInCount);
    };


    const getSEEPZOutData = async () => {
        const List = await getData('seepz', ['Import-Out', 'Export-Out', 'DTA-Export-Out', 'DTA-Import-Out']);
        setSEEPZOutData(List);
        const exportOutCount = List.filter(item => item.typeOfTransaction === 'Export-out').length;
        setExportoutCount(exportOutCount);
        const importOutCount = List.filter(item => item.typeOfTransaction === 'Import-out').length;
        setImportoutcount(importOutCount);
        const subexportOutCount = List.filter(item => item.typeOfTransaction === 'DTA-Export-Out').length;
        setSubexportoutCount(subexportOutCount);
        const subimportOutCount = List.filter(item => item.typeOfTransaction === 'DTA-Import-out').length;
        setSubimportoutcount(subimportOutCount);
    };


    const getData = async (type, trans) => {
        const response = await InviceService.getScanningData(companyid, branchId, type, trans);
        return response.data;
    };


    const convertTimestampToDateTime = (timestamp) => {
        const date = new Date(timestamp);
        // Get the individual components (day, month, year, hours, minutes, seconds)
        const day = date.getDate();
        const month = date.getMonth() + 1; // Note: Months are zero-based, so we add 1
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();

        // Create a formatted date and time string
        const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

        return formattedDateTime;
    }



    const [loading, setLoading] = useState(false);
    const [scanalldata, setScalalldata] = useState('');
    const index1 = scanalldata.length - 4;
    const sir = scanalldata.substring(0, index1).toUpperCase();
    const packnum = scanalldata.substring(index1);



    const handleSubmit1 = () => {
        setLoading(true);
        axios.post(`https://${ipaddress}scan/alldataforseepzgateout/${companyid}/${branchId}/${userId}/${sir}/${packnum}`)
            .then(response => {
                if (response.data === "wrong barcode") {
                    toast.error("Invalid qr or barcode format", {
                        autoClose: 700
                    });
                    setScalalldata('');
                    getSEEPZOutData();
                    setLoading(false);
                    return;
                }

                if (response.data === "not found") {
                    toast.error("Data not found", {
                        autoClose: 700
                    });
                    setScalalldata('');
                    getSEEPZOutData();
                    setLoading(false);
                    return;
                }
                if (response.data === 'NOP is not matched') {
                    toast.success("Data scanned successfully", {
                        autoClose: 700
                    })
                    setScalalldata('');
                    getSEEPZOutData();
                    setLoading(false);
                    return;
                }
                if (response.data === "wrong status") {
                    toast.error("Data hasn't been handed over to Party/CHA or carting agent", {
                        autoClose: 700
                    });
                    setScalalldata('');
                    getSEEPZOutData();
                    setLoading(false);
                    return;
                }
                if (response.data === "Dgdc_seepz_out_scan is already 'Y'") {
                    toast.error("Data already scanned", {
                        autoClose: 700
                    });
                    setScalalldata('');
                    getSEEPZOutData();
                    setLoading(false);
                    return;
                }

                if (response.data === "success") {
                    toast.success("Data scanned successfully", {
                        autoClose: 700
                    });

                    console.log('Post request successful:', response.data);
                    setScalalldata('');
                    getSEEPZOutData();

                    setLoading(false);
                }
                setLoading(false);
            })
            .catch(error => {
                if (error) {
                    toast.error("Data not found", {
                        autoClose: 700
                    });
                }
                setScalalldata('');
                getSEEPZOutData();
                setLoading(false);
            })

    };


    const [scanalldata1, setScalalldata1] = useState('');


    const handleSuccess = (message) => {
        toast.success(message, {
            autoClose: 700,
        });
        resetInputs();
    };

    const handleError = (message) => {
        toast.error(message, {
            autoClose: 700,
        });
        resetInputs();
    };

    const handleError1 = (message) => {
        toast.error(message, {
            autoClose: 1800,
            style: {
                width: '500px'
            }
        });
        resetInputs();
    };

    const resetInputs = () => {
        setScalalldata1('');
    };

    function formatDate1(date) {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear().toString();

        return `${year}-${month}-${day} 00:00:00`;
    }
    const [loading1, setLoading1] = useState(false);



    const checkexportsubout1 = () => {
        setLoading1(true);
        const date = formatDate1(new Date());
        const index2 = scanalldata1.length - 4;
        const sir1 = scanalldata1.substring(0, index2).toUpperCase();
        const pack1 = scanalldata1.substring(index2);
        if (scanalldata1.startsWith("https")) {
            const getScan = {
                companyId: companyid,
                branchId: branchId,
                createdBy: userId,
                editedBy: userId,
                approvedBy: userId,
                link: scanalldata1,
            };
            axios.post(`https://${ipaddress}export/readgateinurl/${date}`, getScan)
                .then((response) => {
                    if (!response.data) {
                        handleError("Data not found");
                        getSEEPZInData()
                        setLoading1(false);
                    } else if (response.data === "found") {
                        handleError("Data already scan");
                        getSEEPZInData()
                        setLoading1(false);
                    }
                    if (response.data === 'NOP is not matched') {
                        handleSuccess("Data scanned successfully");
                        getSEEPZInData()
                        setLoading1(false);
                    }

                    else if (response.data.startsWith("The LOA for the")) {
                        handleError1(response.data);
                        getSEEPZInData()
                        setLoading1(false);
                    }
                    else if (response.data === "success") {
                        handleSuccess("Data scanned successfully");
                        getSEEPZInData()
                        setLoading1(false);
                    } else {
                        console.log('Post request successful:', response.data);
                        handleSuccess("Data scanned successfully");
                        getSEEPZInData()
                        setLoading1(false);
                    }
                    setLoading1(false);
                })
                .catch((error) => {
                    console.error('Error sending post request:', error);
                    if (error.response && error.response.status === 401) {
                        handleError("Data not found.");
                        getSEEPZInData()
                        setLoading1(false);
                    }
                    setLoading1(false);
                    getSEEPZInData()
                });
        } else if (scanalldata1.startsWith("IM")) {

            axios.post(`https://${ipaddress}scan/alldataforseepzgatein/${companyid}/${branchId}/${userId}/${sir1}/${pack1}`)
                .then((response) => {
                    if (response.data === "wrong barcode") {
                        handleError("Invalid qr or barcode format");
                        getSEEPZInData();
                        setLoading1(false);
                    }
                    if (response.data === "not found") {
                        handleError("Data not found");
                        getSEEPZInData();
                        setLoading1(false);
                    }
                    if (response.data === 'NOP is not matched') {
                        handleSuccess("Data scanned successfully");
                        getSEEPZInData()
                        setLoading1(false);
                    }
                    if (response.data === "wrong status") {

                        handleError("Data hasn't been exit from cargo gate");
                        getSEEPZInData();
                        setLoading1(false);
                    }
                    if (response.data === "Dgdc_seepz_out_scan is already 'Y'") {
                        handleError("Data already scanned");
                        getSEEPZInData();
                        setLoading1(false);
                    }
                    if (response.data === "success") {

                        handleSuccess("Data scanned successfully");
                        getSEEPZInData();
                        setLoading1(false);
                    }

                    setLoading1(false);
                })
                .catch((error) => {

                    if (error) {
                        handleError("Data not found");
                        getSEEPZInData();
                        setLoading1(false);
                    }
                    setLoading1(false);
                });

        }
        else {

            InviceService.scanByShippingBill(companyid, branchId, userId, scanalldata1)
                .then((response) => {
                    if (response.data === 'Data Scanned Successfully')
                        handleSuccess("Data Scanned Successfully");
                    getSEEPZInData();
                })
                .catch((error) => {
                    handleError(error.response?.data || "An error occurred");
                    getSEEPZInData();
                })
                .finally(() => {
                    setLoading1(false);
                });
        }

    };




    const inputRef = useRef();

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            document.getElementById("submitButton").click();
        }
    };


    const inputRef1 = useRef();

    const handleKeyPress1 = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            document.getElementById("submitButton10").click();
        }
    };

    const handleExcelDownload = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `https://${ipaddress}scan/download-delivery-register/${companyid}/${branchId}`,
                {
                    responseType: "blob"
                }
            );

            const url = window.URL.createObjectURL(
                new Blob([response.data])
            );

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Delivery_Register.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <>


            <Container>

                <h5 className="pageHead" style={{ fontFamily: 'Your-Heading-Font', paddingLeft: '4%', paddingRight: '-50px' }} > <FontAwesomeIcon
                    icon={faBarcode}
                    style={{
                        marginRight: '8px',
                        color: 'black'
                    }}
                />Scan Parcel</h5>

                <Card  >
                    <CardBody>


                        <Tabs
                            defaultActiveKey="home"
                            transition={false}
                            id="noanim-tab-example"
                            className="mb-3"
                        >

                            <Tab eventKey="home" title="Incoming">
                                {loading1 && (
                                    <div style={styles.overlay}>
                                        <ReactLoading type="spin" color="#0000FF" height={300} width={80} />
                                    </div>
                                )}
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label className="forlabel" for="branchId">Scan URL</Label>
                                            <Input
                                                type="text"
                                                name="remarks"
                                                id="branchname"
                                                placeholder='Scan QR/SIR'
                                                value={scanalldata1}
                                                ref={inputRef1}
                                                onKeyDown={handleKeyPress1}
                                                autoFocus
                                                onChange={(e) => setScalalldata1(e.target.value)}
                                                className="inputField"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <Button id="submitButton10" variant="outline-primary" onClick={checkexportsubout1} style={{ marginTop: 32 }}>
                                            <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                                            Scan
                                        </Button>
                                    </Col>
                                    <Col md={4}>
                                        <Table className="table table-bordered table-hover text-center" style={{ border: '2px solid black' }}>
                                            <thead className="thead-dark bg-dark"  >
                                                <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                                                    <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Type</th>
                                                    <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>IN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td>Export</td>
                                                    <td>{exportincount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Import</td>
                                                    <td>{importincount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Total</td>
                                                    <td>{exportincount + importincount}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                {SEEPZInData && SEEPZInData.length > 0 && (
                                    <Row style={{ marginTop: 30 }}>
                                        <div className="table-responsive">
                                            <Table className="table table-bordered table-hover text-center" style={{ border: '2px solid black' }}>
                                                <thead className="thead-dark bg-dark"  >
                                                    <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Sr No.</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Type of Transaction</th>

                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>SER / SIR NO</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Parcel Type</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>SB/BE No.</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Exporter/Importer Name</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>No. of packages</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Package Number</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Date & Time</th>


                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {SEEPZInData.map((item, index) => (

                                                        <tr key={index} className={item.status === 'Y' ? 'status-Y' : 'status-N'} style={item.status === 'Y' ? { backgroundColor: 'red' } : {}}>

                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }} >{index + 1}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.typeOfTransaction}</td>

                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.srNo}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.parcel_type}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.doc_Ref_No}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.party}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.nop}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.packnum}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{convertTimestampToDateTime(item.gateiout)}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                    </Row>
                                )}

                            </Tab>

                            <Tab eventKey="profile" title="Outgoing">
                                {loading && (
                                    <div style={styles.overlay}>
                                        <ReactLoading type="spin" color="#0000FF" height={300} width={80} />
                                    </div>
                                )}
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label className="forlabel" for="branchId">Scan URL</Label>
                                            <Input
                                                type="text"
                                                name="remarks"
                                                id="branchname"
                                                placeholder='Scan SIR/SER'
                                                value={scanalldata}
                                                onChange={(e) => setScalalldata(e.target.value)}
                                                ref={inputRef}
                                                onKeyDown={handleKeyPress}
                                                className="inputField"
                                                autoFocus
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <Button id="submitButton" variant="outline-primary" onClick={handleSubmit1} style={{ marginTop: 32 }}>
                                            <FontAwesomeIcon icon={faSearch} style={{ marginRight: '5px' }} />
                                            Scan
                                        </Button>
                                    </Col>

                                    <Col md={4}>
                                        <Table className="table table-bordered table-hover text-center" style={{ border: '2px solid black' }}>
                                            <thead className="thead-dark bg-dark"  >
                                                <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                                                    <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Type</th>
                                                    <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>OUT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="text-center">
                                                    <td>Export</td>
                                                    <td>{exportoutcount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Import</td>
                                                    <td>{importoutcount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Sub-Export</td>
                                                    <td>{subexportoutcount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Sub-Import</td>
                                                    <td>{subimportoutcount}</td>
                                                </tr>
                                                <tr className="text-center">
                                                    <td>Total</td>
                                                    <td>{exportoutcount + importoutcount + subexportoutcount + subimportoutcount}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                                <Button
                                    type="button"
                                    variant="outline-success"
                                    style={{ marginRight: "10px", marginBottom: "15px" }}
                                    onClick={handleExcelDownload}
                                >
                                    <FontAwesomeIcon
                                        icon={faFileExcel}
                                        style={{ marginRight: "5px" }}
                                    />
                                    XLS
                                </Button>
                                <Row>


                                </Row>


                                {SEEPZOutData && SEEPZOutData.length > 0 && (
                                    <Row style={{ marginTop: 30 }}>
                                        <div className="table-responsive">
                                            <Table className="table table-bordered table-hover text-center" style={{ border: '2px solid black' }}>
                                                <thead className="thead-dark bg-dark">
                                                    <tr style={{ fontWeight: 'bold', border: '2px solid black', fontSize: '17px' }}>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Sr No.</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Type of Transaction</th>

                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>SER / SIR NO</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Parcel Type</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>SB/BE No.</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Exporter/Importer Name</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>No. of packages</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Package Number</th>
                                                        <th scope="col" className="text-center" style={{ backgroundColor: '#80cbc4', color: 'black', fontFamily: 'Your-Heading-Font' }}>Date & Time</th>


                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {SEEPZOutData.map((item, index) => (

                                                        <tr key={index} className={item.status === 'Y' ? 'status-Y' : 'status-N'} style={item.status === 'Y' ? { backgroundColor: 'red' } : {}}>

                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }} >{index + 1}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.typeOfTransaction}</td>

                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.srNo}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.parcel_type}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.doc_Ref_No}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.party}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.nop}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{item.packnum}</td>
                                                            <td style={item.status === 'Y' ? { backgroundColor: '#b0e8dc', textAlign: 'center', fontFamily: 'Your-Data-Font' } : { textAlign: 'center', fontFamily: 'Your-Data-Font' }}>{convertTimestampToDateTime(item.gateiout)}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>

                                    </Row>
                                )}
                            </Tab>


                        </Tabs>



                    </CardBody>
                </Card  >
            </Container>




        </>

    )
}













